import {KeyboardEvent, KeyboardEventHandler} from 'react';

import {includes} from 'ramda';

const ACTIVATION_KEYS = ['Enter', ' '];

export function createActivationKeyDownHandler(
  onActivate: (event: KeyboardEvent<HTMLDivElement>) => void
): KeyboardEventHandler<HTMLDivElement> {
  return (event) => {
    if (includes(event.key, ACTIVATION_KEYS)) {
      event.preventDefault();
      onActivate(event);
    }
  };
}
